import { useEffect, useRef } from 'react';
import { de } from '@/i18n/de';
import { useAppStore } from '@/lib/store';
import { useCountdown } from '@/lib/clock';
import { haptics } from '@/lib/haptics';
import { sound } from '@/lib/sound';
import { AppShell } from '@/components/AppShell';

export function CountdownScreen() {
  const view = useAppStore((s) => s.view);
  const seconds = useCountdown(view?.phaseEndsAt ?? null);
  const lastTick = useRef<number | null>(null);

  useEffect(() => {
    if (seconds === lastTick.current || seconds <= 0) return;
    lastTick.current = seconds;
    haptics.tick();
    sound.tick();
  }, [seconds]);

  if (!view) return null;

  return (
    <AppShell>
      <div className="flex h-full flex-col items-center justify-center gap-6 text-center">
        <p className="font-display text-xl text-fg-muted">{de.countdown.title}</p>
        {/* `key` startet die CSS-Animation bei jeder Ziffer neu — dasselbe
            Muster wie beim Phasenwechsel in `App.tsx` und aus demselben Grund
            kein `AnimatePresence`: dessen `mode="wait"` lässt die nächste
            Ziffer erst zu, wenn die vorige fertig ausgeblendet ist, und ein
            Countdown, der auf einer Zahl stehen bleibt, ist schlimmer als einer
            ohne Animation. */}
        <span
          key={seconds}
          className="animate-count-in font-display text-[9rem] leading-none font-extrabold tabular-nums text-accent"
        >
          {Math.max(seconds, 0)}
        </span>
      </div>
    </AppShell>
  );
}
